import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet'

import './Home.css'
import RecurringPage from '../components/recurring-page/RecurringPage';
import DeletedPage from '../components/deleted-page/DeletedPage';
import IssuePage from '../components/issue-page/IssuePage';
import ClientsPage from '../components/clients-page/ClientsPage';
import HistoryPage from '../components/history-page/HistoryPage';
import PreInvoicesPage from '../components/pre-invoices-page/PreInvoicesPage';
import Sidebar from '../components/layout/Sidebar';

function getTenantFromHostname() {
  const hostname = window.location.hostname;
  let tenant = hostname.split('.')[0]; // e.g., "besthomes" from "besthomes.nap-pro.com"
  if (tenant === 'localhost' || tenant === '127.0.0.1') {
    const persisted = localStorage.getItem('tenantName');
    tenant = persisted;
  }
  return tenant;
}


function Home() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [view, setView] = useState('issue'); // 'issue', 'automatic', 'deleted'
  const [tenantName, setTenantName] = useState(getTenantFromHostname());

  useEffect(() => {
    window.scrollTo(0, 0);
    setSidebarOpen(false); // Close sidebar on mobile when navigating
  }, [view]);

  useEffect(() => {
    if (tenantName) {
      document.documentElement.setAttribute('data-tenant', tenantName);
    }
  }, [tenantName]);

  return (
    <div className="home-container1">
      <Helmet>
        <title>Nap-Pro</title>
        <meta property="og:title" content="Nap-Pro" />
      </Helmet>
      <div className="home-container2 flex">
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          tenantName={tenantName}
          currentView={view}
          onNavigate={setView}
        />
        <div className="home-content flex-1 overflow-x-hidden">
          {/* Mobile Header */}
          <div className="lg:hidden fixed top-0 left-0 right-0 z-40 flex items-center justify-between p-4 bg-white border-b border-gray-100 shadow-sm">
            <h1 className="font-bold text-gray-900 text-lg truncate max-w-[200px]">{tenantName || 'Nap-Pro'}</h1>
            <button 
              onClick={() => setSidebarOpen(true)}
              className="p-2 text-gray-500 hover:bg-gray-100 rounded-md transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
            </button>
          </div>
          {/* Spacer for fixed header */}
          <div className="lg:hidden h-[73px] w-full mb-4"></div>

          {view === 'issue' && <IssuePage tenantName={tenantName} />}
          {view === 'recurring' && <RecurringPage tenantName={tenantName} />}
          {view === 'deleted' && <DeletedPage tenantName={tenantName} />}
          {view === 'clients' && <ClientsPage tenantName={tenantName} />}
          {view === 'preinvoices' && <PreInvoicesPage tenantName={tenantName} />}
          {view === 'history' && <HistoryPage tenantName={tenantName} />}
        </div>
      </div>
    </div>
  )
}

export default Home;